import { UserCog, Map, Zap, Building2, BarChart3, GraduationCap } from "lucide-react";
import { motion } from "framer-motion";

const ITEMS = [
  { icon: UserCog, title: "Dedicated Claim Manager", desc: "A personal claim expert assigned from intimation to settlement.", tone: "text-blue-800 dark:text-blue-400", bg: "bg-blue-700/10" },
  { icon: Map, title: "Pan-India Assistance", desc: "Anywhere in India — accident help, towing & survey coordination.", tone: "text-emerald-600 dark:text-emerald-400", bg: "bg-emerald-500/10" },
  { icon: Zap, title: "Faster Processing", desc: "We chase paperwork & approvals so you don't. Significant time saved.", tone: "text-orange-500 dark:text-orange-400", bg: "bg-orange-500/10" },
  { icon: Building2, title: "Cashless Workshop Network", desc: "12,000+ partner garages with zero out-of-pocket repair coordination.", tone: "text-orange-600 dark:text-orange-400", bg: "bg-orange-500/10" },
  { icon: BarChart3, title: "Transparent Tracking", desc: "Real-time claim status, timeline, and document approvals — always on.", tone: "text-pink-600 dark:text-pink-400", bg: "bg-pink-500/10" },
  { icon: GraduationCap, title: "Expert Guidance", desc: "20+ years of motor insurance know-how working for you.", tone: "text-violet-600 dark:text-violet-400", bg: "bg-violet-500/10" },
];

export default function WhyChooseUs() {
  return (
    <section className="py-24 relative" data-testid="why-choose-us">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-14 max-w-2xl mx-auto">
          <div className="text-xs font-bold uppercase tracking-[0.2em] text-blue-800 dark:text-blue-400 mb-2">
            Why Choose Us
          </div>
          <h2 className="font-heading text-3xl sm:text-4xl font-extrabold tracking-tight text-slate-900 dark:text-white">
            Built for policyholders, not insurers.
          </h2>
          <p className="mt-3 text-slate-600 dark:text-slate-400">
            We work for <span className="font-semibold text-slate-800 dark:text-slate-200">you</span> — not for the insurance company. Independence is our biggest feature.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {ITEMS.map((it, i) => {
            const Icon = it.icon;
            return (
              <motion.div
                key={it.title}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.4, delay: i * 0.05 }}
                className="card-premium p-6 group"
                data-testid={`why-${it.title.toLowerCase().replace(/\s+/g, "-")}`}
              >
                <div className={`w-12 h-12 rounded-xl ${it.bg} ${it.tone} flex items-center justify-center mb-5 transition-transform group-hover:scale-110`}>
                  <Icon className="w-6 h-6" />
                </div>
                <h3 className="font-heading font-bold text-lg text-slate-900 dark:text-white mb-2">{it.title}</h3>
                <p className="text-sm text-slate-600 dark:text-slate-400 leading-relaxed">{it.desc}</p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
